<template>
  <div class="col-xxl-6 col-xl-12 col-lg-12 col-md-12col-12">
    <div class="card">
      <div class="card-header">
        <div class="title">Transactions by time of day</div>
      </div>
      <div class="card-body">
        <apexchart
          height="350"
          type="bar"
          :options="chartOptions"
          :series="chartSeries"
        ></apexchart>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useReportStore } from '@/store/driver/report';

const reportStore = useReportStore();

const chartOptions = {
  chart: {
    type: 'bar',
    height: 350,
    stacked: true,
    redrawOnWindowResize: true,
  },
  plotOptions: {
    bar: {
      horizontal: true,
      barHeight: '50%',
    },
  },
  colors: ['#00E396', '#00C962'],
  xaxis: {
    categories: [
      '00:01 to 02:00', '02:01 to 04:00', '04:01 to 06:00',
      '06:01 to 08:00', '08:01 to 10:00', '10:01 to 12:00',
      '12:01 to 14:00', '14:01 to 16:00', '16:01 to 18:00',
      '18:01 to 20:00', '20:01 to 22:00', '22:01 to 00:00'
    ],
    labels: {
      style: {
        fontSize: '12px',
      },
    },
  },
  yaxis: {
    labels: {
      style: {
        fontSize: '14px',
      },
    },
  },
  tooltip: {
    y: {
      formatter: function (val) {
        return val + "%";
      },
    },
  },
  grid: {
    xaxis: {
      lines: {
        show: false,
      },
    },
    yaxis: {
      lines: {
        show: false,
      },
    },
  },
  dataLabels: {
    enabled: true,
    formatter: function (val) {
      return val + "%";
    },
    offsetX: 0,
    style: {
      fontSize: '14px',
      colors: ['#000'],
    },
  },
};

const chartSeries = computed(() => {
  const faceValueByTime = reportStore.reportInfo.face_value_by_time_of_day;
  return [
    {
      name: 'Percentage',
      data: Object.values(faceValueByTime),
    },
  ];
});
</script>

<style scoped>
.card {
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  min-height: 550px;
}

.card-body {
  padding: 20px;
}

.title{
  font-family: Euclid Square;
  font-size: 24px;
  font-weight: 500;
  line-height: 30.43px;
  text-align: left;
}

.apexcharts-bar-area {
  fill: #00C962 !important;
}

.apexcharts-bar {
  stroke-width: 0;
}
</style>